import { Controller } from "stimulus";

// Warns (without blocking) when the certificate expiration date precedes the
// certificate date on the historic attendee form.
export default class extends Controller {
  static targets = ["start", "end", "warning"];

  connect() {
    this.check();
  }

  check() {
    if (this.hasWarningTarget) {
      this.warningTarget.classList.toggle("d-none", !this.datesInverted());
    }
  }

  confirmSubmit(event) {
    if (this.datesInverted() && !window.confirm("La data scadenza è precedente alla data attestato. Salvare comunque?")) {
      event.preventDefault();
    }
  }

  datesInverted() {
    if (!this.hasStartTarget || !this.hasEndTarget) return false;
    const start = this.startTarget.value;
    const end = this.endTarget.value;
    // ISO yyyy-mm-dd values: lexicographic comparison matches chronological order
    return Boolean(start) && Boolean(end) && end < start;
  }
}
